import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { nftJsonState } from "../../states/nftJsonState";
import { configJsonState } from "../../states/configJsonState";
import { langState } from "../../states/langState";
import { useRecoilState, useRecoilValue } from 'recoil';//取得のみ


import { HasWalletutton } from '../../components/hasWalletButtonComponent';
import { NFTImage } from '../../components/nftImageComponent';
import { NFTInfoText } from '../../components/nftInfoComponent';
import { GetNFTButton } from '../../components/getNFTButton';
import { SushiFooter } from '../../components/suishiFooterComponent';


import { Box, useDisclosure ,Checkbox, CheckboxGroup ,Button,Text,Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,ModalFooter} from '@chakra-ui/react'
import { NFTInfoName } from '../../components/nftInfoTextNameComponent';
import { NFTInfoDescription } from '../../components/nftInfoTextDescriptionComponent';

import { LoadingModal } from "../../components/modal/loadingModalComponent";
import { RulesModal } from '../../components/modal/rulesModalComponent';
import { NoWalletButton } from '../../components/noWalletButton';
import { languageState } from '../../states/languageState';
import { UnWalletButton } from '../../components/unWalletButton';
import { AlphaUWalletButton } from '../../components/aUWalletButton';
import { useNavigate } from 'react-router-dom';



type Props = {}

export const IndexPage: React.FC<Props> = (props) => {
  
  const nftInfoStatus = useRecoilValue(nftJsonState);
  const [t, i18n] = useTranslation();
  const [configStatus , setConfigStatus] = useRecoilState(configJsonState);
  const [langStatus , setLangStatus] = useRecoilState(langState);


  const { isOpen:isOpenLoadModal, onOpen:onOpenLoadModal, onClose:onCloseLoadModal } = useDisclosure();
  const { isOpen:isOpenRulesModal, onOpen:onOpenRulesModal, onClose:onCloseRulesModal } = useDisclosure();
  const [scrollBehavior, setScrollBehavior] = React.useState('inside')
  const btnRef = React.useRef(null);
  const [walletTypeArrayStatus , setWalletTypeArrayStatus] = React.useState([]);
  const [languageStatus , setLanguageStatus] = useRecoilState(languageState);



  const indexPageMainStyle: React.CSSProperties = {
    minHeight:'calc(100vh - 60px)',
    textAlign: 'center',
    fontFamily: "Noto Sans JP,sans-serif",
    width: '100%',
    height:'100vh',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    flex:1,
    color: '#FFFBFB',

    backgroundImage: `url(${configStatus.backgroundImage})`,
  };
  const SwitchButtondiv = styled.div`
    display: inline-flex;
    position: fixed;
    top: 5px;
    font-weight: 600;
    right: 30px;
  `;
  const ENButtonP = styled.div`
    color:${languageStatus.enButtonColor};
    font-weight: 600;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  `;
  const navigate = useNavigate();

  const JPButtonP = styled.div`
    color:${languageStatus.jaButtonColor};
    font-weight: 600;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  `;

  const IndexPageDiv = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `;


  React.useEffect(()=>{
    //最上部にスクロール
    window.scrollTo(0,0);
    console.log(`TopShot`);

  },[]);


  return (
    <>
      <IndexPageDiv>
        <main style={indexPageMainStyle}>
          <SwitchButtondiv>
            <ENButtonP
              id='btn-default-en' 
              onClick={()=>{
                i18n.changeLanguage(`en`);
                setLanguageStatus({
                  lang:`en`,
                  jaButtonColor:`darkslategrey`,
                  enButtonColor:`white`,
                  isFirstSetting:true,
                })
              }}

            >EN
            </ENButtonP>
            <p>・</p>
            <JPButtonP 
              id='btn-default-jp'
              onClick={()=>{
                i18n.changeLanguage(`ja`);
                setLanguageStatus({
                  lang:`ja`,
                  jaButtonColor:`white`,
                  enButtonColor:`darkslategrey`,
                  isFirstSetting:true,
                })
              }}
            >JP
            </JPButtonP>
          </SwitchButtondiv>


          {nftInfoStatus.chainId && <NFTImage /> }
          {nftInfoStatus.chainId && <NFTInfoName/> }

          {/* {nftInfoStatus.chainId && 
            <Checkbox 
              mb={'10px'}
            >
              <Box 
                as='span' 
                color={'red'} 
                fontWeight={'bold'}
                textDecoration={'underline'}
                ref={btnRef} 
                onClick={onOpenRulesModal}
              >利用規約</Box>に同意します
            </Checkbox> 
          } */}


          {(nftInfoStatus.chainId && configStatus.walletTypeArray.length == 1 && configStatus.walletTypeArray.includes(`browserWallet`) ) && 
            <GetNFTButton buttonText={t('アンケートに答える')}/>
          }

          {(nftInfoStatus.chainId && configStatus.walletTypeArray.includes(`unWallet`) && configStatus.walletTypeArray.length == 1) && 
            <UnWalletButton buttonText={t('NFTを受け取る')}/>
          }

          {(nftInfoStatus.chainId && configStatus.walletTypeArray.includes(`auWallet`) && configStatus.walletTypeArray.length == 1) && 
            <AlphaUWalletButton buttonText={t('NFTを受け取る')}/>
          }


          {(nftInfoStatus.chainId && configStatus.walletTypeArray.length > 1) && 
            <Box>
              <Text mb={`3px`}>- {t(`NFTの受け取り方法選択`)} -</Text>
              <NoWalletButton buttonText={t('ウォレットをお持ちでない方')}/>
              <Box h={`15px`}/>
              <HasWalletutton buttonText={t('ウォレットをお持ちの方')}/>
            </Box>
          }



          {nftInfoStatus.description &&  <NFTInfoDescription/>}
        </main>
        <SushiFooter footerPragraph1='powered by' footerPragraph2='- Creating a Token-Graph Marketing Culture -'/>
      </IndexPageDiv>
    
      {/* 利用規約用モーダル */}
      <RulesModal
        onClose={onCloseRulesModal}
        isOpen={isOpenRulesModal}
        btnRef={btnRef}
      />

      {/* 待機用モーダル */}
      <LoadingModal 
        // isOpen={!nftInfoStatus.chainId?true:false} 
        isOpen={(nftInfoStatus.chainId && !sessionStorage.getItem(`mint_use_unWalletAddress`))?false:true} 
        onClose={onCloseLoadModal}
      />
    </>
  );
};